import {useMutation, UseMutationResult} from '@tanstack/react-query';

import {serialize} from '../../util/api-adapter';
import {FetchMethodEnum, fetchX} from '../../util/fetch';
import {getCsrfHeaders, mainApiHeaders, rootApiUrl} from '../api/api-const';

function updateFavoriteSections(sections: Array<string>): Promise<void> {
    return fetchX<void>(`${rootApiUrl}/cp/user/favorite_sections/`, {
        method: FetchMethodEnum.put,
        body: JSON.stringify(serialize({sections})),
        headers: {...mainApiHeaders, ...getCsrfHeaders()},
    });
}

export function useUserFavoriteSectionsMutation(): UseMutationResult<void, unknown, Array<string>> {
    return useMutation({
        mutationFn: updateFavoriteSections,
    });
}
